// removed by extract-text-webpack-plugin
module.exports = {"noEntries":"cms__CollectionPage__noEntries"};


//////////////////
// WEBPACK FOOTER
// ./containers/CollectionPage.css
// module id = 593
// module chunks = 0